import React from 'react';
import MarkerClusterLayer from './MarkerClusterLayer'

class LivecamLayer extends React.Component {

  constructor(props) {
    super(props);
    this.getGridSize = this.getGridSize.bind(this);
    this.state = {
      id: "livecams",
      type: "markerClusterOverlay",
      configType: "geojson",
      icons: {
        "cluster_icon_class": "p0 maptool-cluster-album",
        "marker_icon_class": "image-border maptool-marker-shadow"
      },
      propertyKey: "thumbnail",
      context: "lity"
    };
  }

  getGridSize() {
    const zoom = this.props.layerContainer.getZoom();
    switch (true) {
      case zoom >= 10:
        return 30;
      case zoom < 10 && zoom >= 8:
        return 50;
      default:
        return 80;
    }
  }

  render() {
    return <MarkerClusterLayer
      id={this.state.id}
      type={this.state.type}
      configType={this.state.configType}
      url={this.props.url}
      icons={this.state.icons}
      clusterFunction={this.state.clusterFunction}
      precision={this.state.precision}
      propertyKey={this.state.propertyKey}
      iconSize={this.state.iconSize}
      iconAnchor={this.state.iconAnchor}
      leafletMap={this.props.layerContainer}
      toggleLoadingIndicator={this.props.toggleLoadingIndicator}
      gridSize={this.getGridSize()}
      context="lity" />;
  }

}

export default LivecamLayer;



/** WEBPACK FOOTER **
 ** ./core_components/DataLayer/LivecamLayer.js
 **/